// src/contexts/DepartmentContext.js
import React, { createContext, useState } from "react";

export const DepartmentContext = createContext();

export const DepartmentProvider = ({ children }) => {
    const [dataDepartment, setDataDepartment] = useState({
        region: null,
        commune: null,
        holder: { value: null, id: null },
        department: null,
    });
    const [view, setView] = useState(false);
    const [viewObserved, setViewObserved] = useState(false);
    const [viewResponseObservation, setViewResponseObservation] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [currentRequestType, setCurrentRequestType] = useState('purchase');
    const [messageConfirmation, setMessageConfirmation] = useState(false);
    const [supereducAccount, setSupereducAccount] = useState('');
    const [responseRequest, setResponseRequest] = useState({
        responseRequest: null,
        sendTo: null,
        comments: '',
        backups: []
    });

    const showNotificationDepartment = (value, type) => {
        setMessageConfirmation(value);

        if (value) {
            setTimeout(() => {
                setMessageConfirmation(false);
            }, 3000);
        }

        if (type && type === 'sendRequest') {
            setSelectedRequest(null);
            setTimeout(() => {
                setResponseRequest({
                    responseRequest: null,
                    sendTo: null,
                    comments: '',
                    backups: []
                })
            }, 3000);
        }
    };

    return (
        <DepartmentContext.Provider value={{
            dataDepartment, setDataDepartment,
            view, setView,
            viewObserved, setViewObserved,
            viewResponseObservation, setViewResponseObservation,
            selectedRequest, setSelectedRequest,
            currentRequestType, setCurrentRequestType,
            messageConfirmation, setMessageConfirmation,
            responseRequest, setResponseRequest,
            supereducAccount, setSupereducAccount,
            showNotificationDepartment
        }}>
            {children}
        </DepartmentContext.Provider>
    );
};
